<script>
import i18n from "../i18n";
import vue2Dropzone from "vue2-dropzone";
import Button from "@/components/c-button";
import { utils } from "../helpers/utils";
// import { settingService } from "../services/settingservice/setting.service";
/* eslint-disable no-console */

var api_server = JSON.parse(localStorage.getItem('client'));

/**
 * Browse File component
 */
export default {
  components: {
    vueDropzone: vue2Dropzone,
    Button
  },
  data() {
    return {
      dropzoneOptions: {
        url: `${api_server.api}/api/v1/upload`,
        thumbnailWidth: 150,
        maxFiles: this.maxFiles,
        addRemoveLinks: true,
      },
      path: api_server.url,
    };
  },
  mounted() {

    console.warn(`${api_server.api}/api/v1/upload`);
  },
  methods: {
    visibleLoading: function() {
      return this.requesting;
    },
    visbleIcon: function () {
      return this.icon !== '' && this.requesting ? false : true;
    },
    translate: function(name) {
      return i18n.t(name);
    },

    uploadSuccess(file, response) {
        this.$emit('uploadSuccess', file, response);
    },
    uploadError(file, message) {
        console.log(file, message, 'An Error Occurred');
    },
    sendingEvent (file, xhr, formData) {
      console.log(file, xhr);
      formData.append('path', this.path);
    }, 

    renderImage(name) {
      console.log("DDDDD", JSON.stringify(name));
      return name == '' ? null : utils.renderImage(name);
    },

    submitCancel() {
      this.preview = null;
    }
  },
  computed: {
    
  },
  props: {
    maxFiles: {
      type: Number,
      default: 1,
    }, 
    id: {
      type: String,
    },
    label: {
      type: String,
      default: ''
    },
    preview: null,
    disabled: {
      default: false
    }
  },
};
</script>
<template>
  <div class="form-group">

    <b-form-group
      class="mb-3"
      :label="$t(label)"
      :label-for="id"
    > 
      <!-- //https://storage.googleapis.com/pn-storages/dev/cartoon_1620452328.jpg -->
      <div v-if="this.preview != null && this.preview != ''" class="row">
        <div class="col-md-12" style="width: %100; display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; align-items: center;">
          <img
            class="rounded"
            alt="200x200"
            width="100%"
            :src="renderImage(this.preview)"
            data-holder-rendered="true" />
          <div style="position: absolute; margin: 10px; padding: 5px;">
              <div inline class="row gy-2 gx-3 align-items-end">
                <div class="col-sm-auto">
                  <Button v-bind:icon="'bx bx-x-circle'" 
                    v-bind:buttonType="'button'"
                    v-bind:variant="'light'"
                    @click="submitCancel()"
                    v-bind:title="$t('general.remove')"  />
                </div>
              </div>
          </div>
        </div>
      </div>
      <div v-else>
        <vue-dropzone
          :id="id"
          :ref="('ref').concat(id)"
          :options="dropzoneOptions"
          :useCustomSlot="true"
          :disabled="disabled"
          
          v-on:vdropzone-sending="sendingEvent"
          v-on:vdropzone-success="($file, $response) => uploadSuccess($file, $response)"
          v-on:vdropzone-error="uploadError"
          v-on:vdropzone-removed-file="fileRemoved"
        >
          <div class="dropzone-custom-content">
            <i class='display-4 bx bx-cloud-upload'></i>
            <h6>{{$t('general.drop-zone')}}</h6>
          </div>
        </vue-dropzone>
      </div>
    </b-form-group>
  </div>
</template>